import { Hub } from '@aws-amplify/core';
import { reportAuthEvent } from './authTelemetry';

const KEY = 'tegrat_apple_sign_in_attempt';
const ERROR_NAMES = new Set(['OAuthSignInError', 'OAuthNotConfigureException', 'AuthTokenConfigException',
  'UserAlreadyAuthenticatedException', 'InvalidStateException', 'InvalidOriginException',
  'NotAuthorizedException', 'NetworkError', 'TypeError', 'SecurityError', 'Unknown']);
let attemptId;
function getAttemptId(fresh) {
  try {
    if (fresh) attemptId = undefined;
    attemptId ||= sessionStorage.getItem(KEY);
    if (fresh || !attemptId) attemptId = crypto.randomUUID();
    sessionStorage.setItem(KEY, attemptId);
  } catch { /* Diagnostics must never interrupt sign-in. */ }
  return attemptId;
}

// Only bounded codes and booleans: never send URLs, OAuth state/code, tokens,
// email, or provider error messages (which can contain private information).
export function logAppleAuth(stage, details = {}) {
  try {
    const diagnostics = { stage, attempt_id: getAttemptId(stage === 'redirect_start') };
    for (const key of ['has_code', 'has_state', 'has_error', 'has_id_token']) {
      if (typeof details[key] === 'boolean') diagnostics[key] = details[key];
    }
    if (Number.isInteger(details.status)) diagnostics.status = details.status;
    if (details.error) {
      diagnostics.error_name = ERROR_NAMES.has(details.error.name) ? details.error.name : 'Unknown';
      const message = typeof details.error.message === 'string' ? details.error.message : '';
      const code = ['invalid_grant', 'invalid_request', 'invalid_client', 'unauthorized_client', 'access_denied', 'server_error', 'temporarily_unavailable'].find(value => message.includes(value));
      if (code) diagnostics.error_code = code;
    }
    void reportAuthEvent('apple_sign_in_diagnostic', 'challenge', undefined, diagnostics);
  } catch { /* Best effort only. */ }
}

// Register before Amplify.configure: redirect completion can precede React effects.
export function installAppleAuthDiagnostics() {
  return Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'signInWithRedirect') logAppleAuth('oauth_complete');
    if (payload.event === 'signInWithRedirect_failure') logAppleAuth('oauth_failure', { error: payload.data?.error });
  });
}
